import React, {
  useEffect, useRef, useState
} from 'react';
import { Carousel } from 'react-responsive-carousel';

import Wrapper from '../../basic/Wrapper';

const CarouselComponent = (props) => {
  const { attributes, children } = props;
  const {
    carouselNumber, className, maximumScreenSize, numOfSlidesInContainer,
  } =
    attributes;

  const [numOfSlidesInScreen, setNumOfSlidesInScreen] = useState(numOfSlidesInContainer);
  const [showInCarousel, setShowInCarousel] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevIsDisabled, setPrevIsDisabled] = useState(true);
  const [nextIsDisabled, setNextIsDisabled] = useState(false);
  const prevButton = useRef(null);
  const nextButton = useRef(null);
  const transitionTime = 1000;

  const getShowInCarousel = () =>
    !maximumScreenSize || window?.innerWidth < Number.parseInt(maximumScreenSize);

  useEffect(() => {
    import('react-responsive-carousel/lib/styles/carousel.min.css');

    window.addEventListener('resize', () => {
      setShowInCarousel(getShowInCarousel());

      var slidesOnStage = window?.innerWidth < 768 ? 1 : numOfSlidesInScreen;

      setNumOfSlidesInScreen(slidesOnStage);
      props?.setCarouselCurrentSlide
        ? props.setCarouselCurrentSlide(currentSlide - 1 + slidesOnStage)
        : null;
    });

    var slidesOnStage = window?.innerWidth < 768 ? 1 : numOfSlidesInScreen;

    setShowInCarousel(getShowInCarousel());
    setNumOfSlidesInScreen(numOfSlidesInScreen);
    props?.setCarouselCurrentSlide
      ? props.setCarouselCurrentSlide(currentSlide - 1 + slidesOnStage)
      : null;
  }, [currentSlide]);

  useEffect(() => {
    if (!prevButton.current) {
      prevButton.current = carouselNumber
        ? document.querySelectorAll('[data-prev]')[carouselNumber - 1]
        : document.querySelector('[data-prev]');
    }

    if (!nextButton.current) {
      nextButton.current = carouselNumber
        ? document.querySelectorAll('[data-next]')[carouselNumber - 1]
        : document.querySelector('[data-next]');
    }

    window[`carouselNext${carouselNumber || ''}`] = () => {
      setCurrentSlide(currentSlide + 1);
    };

    var prevIsDisabled = currentSlide === 0 ? true : false;
    var nextIsDisabled =
      currentSlide === children.length - Number.parseInt(numOfSlidesInScreen || 1)
        ? true
        : false;

    setPrevIsDisabled(prevIsDisabled);
    setNextIsDisabled(nextIsDisabled);

    window[`carouselPrev${carouselNumber || ''}`] = () => {
      setCurrentSlide(currentSlide - 1);
    };
  }, [currentSlide]);

  // @TODO: Create Container State component and deperecate sharing state w/ vanilla js
  useEffect(() => {
    if (prevButton.current) {
      if (prevIsDisabled) {
        prevButton.current.dataset.active = prevIsDisabled;
      } else {
        delete prevButton.current.dataset.active;
      }
    }
  }, [prevIsDisabled]);

  useEffect(() => {
    if (nextButton.current) {
      if (nextIsDisabled) {
        nextButton.current.dataset.active = nextIsDisabled;
      } else {
        delete nextButton.current.dataset.active;
      }
    }
  }, [nextIsDisabled]);

  const updateCurrentSlide = (index) => {
    index =
      index <= children.length - Number.parseInt(numOfSlidesInScreen || 1)
        ? index
        : index - 1;

    setCurrentSlide(index);
  };

  return showInCarousel ? (
    <div className={`CarouselWrapper${carouselNumber || ''} ${className}`}>
      <Carousel
        emulateTouch={true}
        infiniteLoop={false}
        onChange={updateCurrentSlide}
        onClickItem={updateCurrentSlide}
        renderArrowNext={() => null}
        selectedItem={currentSlide}
        showArrows={false}
        showIndicators={false}
        showThumbs={false}
        statusFormatter={() => null}
        transitionTime={transitionTime}
      >
        {/* // @TODO: Fix locale turn off/on from adding undefined's */}
        {children.filter ? children.filter((child) => !!child) : children}
      </Carousel>
    </div>
  )

    :
    <Wrapper attributes={attributes}>{children}</Wrapper>;
};

export default CarouselComponent;
